import React, { Component } from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import API from '../../utils/api';

import { observer, inject } from "mobx-react";
import { getCurrentOrg, getAllClasses } from "../../utils/operations.js";
import { toast } from 'react-toastify';

class NewClasses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        organisation_id: "",
        name: ""
      },
      organisations: [], // Список организаций
      opendialog: false, // Диалог с ошибками
      texterrors: "" // Список ошибок
    };
  }

  // Получение роли для создания нового пользователя
  componentDidMount() {
    if (!this.props.Auth.can('classes_edit')) { this.props.history.push("/children"); return; }
    this.loadData();
  }

  loadData = () => {
    const data = this.state.data;
    let orgId = this.props.Auth.orgId;

    API.get(getCurrentOrg + orgId).then(res => {
      data.name = "";
      data.organisation_id = res.data.id;
      this.setState({ organisations: [res.data] });
      this.setState({ data });
    });
  };

  // Запись данных в базу
  saveData = () => {
    if (!this.state.data.name.trim()) {
      toast.error("Class name is required.");
      return;
    }
    this.setState({ showProgress: true });

    let data = {
      resource: [
        {
          name: this.state.data.name,
          organisation_id: this.state.data.organisation_id
        }
      ]
    };

    API.post(getAllClasses, data).then(() => {
      toast.success('Class successfully added!');
      this.props.history.push("/classes");
    })
    .catch((error) => {
      toast.error(error.response?.data?.message || 'Error saving class');
    });
  };

  // Открыть диалог
  handleOpen = () => {
    this.setState({ opendialog: true });
  };

  // Закрыть диалог
  handleClose = () => {
    this.setState({ opendialog: false });
  };

  // Записать Select в state
  handleOrgChange = (event) => {
    const data = this.state.data;
    data.organisation_id = event.target.value;
    this.setState({ data });
  };

  // Записать данные в state
  handleChange = event => {
    const data = this.state.data;
    data[event.target.id] = event.target.value;
    this.setState({ data });
  };

  // Перейти на предыдущую страницу
  goPreviousPage = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <div style={{ maxWidth: 500, margin: "auto" }}>
        <p>Class</p>
        <TextField
          id="name"
          label="Class Name"
          fullWidth
          value={this.state.data.name}
          onChange={this.handleChange}
          error={!this.state.data.name.trim()}
          helperText={!this.state.data.name.trim() ? "Class name is required" : ""}
          sx={{ mb: 2 }}
        />
        <FormControl fullWidth disabled sx={{ mb: 2 }}>
          <InputLabel id="org-label">School</InputLabel>
          <Select
            labelId="org-label"
            label="School"
            value={this.state.data.organisation_id}
            onChange={this.handleOrgChange}
          >
            {this.state.organisations.map(row => (
              <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 20,
            paddingBottom: 20
          }}
        >
          <Button variant="contained" color="primary" onClick={this.saveData}>Save</Button>
          <Button variant="contained" color="secondary" onClick={this.goPreviousPage}>Cancel</Button>
        </div>

        <Dialog open={this.state.opendialog} onClose={this.handleClose}>
          <DialogTitle>Form errors:</DialogTitle>
          <DialogContent>
            {this.state.texterrors.split("\n").map((i, index) => (
              <div key={index}>{i}</div>
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default inject("Auth")(observer(NewClasses))
